import classNames from 'classnames'
import { useCallback } from 'react'
import styles from './styles.module.scss'

export type ISkeletonRectangleProps = {
  className?: string
  enableRandomWidth?: boolean
  customWidth?: number | string
  animated?: boolean
}

const randomWidth = () => {
  const min = 30
  const max = 50
  const value = Math.random() * (max - min) + min
  return `${value}%`
}

export const SkeletonRectangle = ({
  className,
  enableRandomWidth,
  customWidth,
  animated,
}: ISkeletonRectangleProps) => {
  const width = useCallback(() => {
    if (customWidth) return customWidth
    if (enableRandomWidth) return randomWidth()

    return '100%'
  }, [enableRandomWidth, customWidth])

  return (
    <div
      className={classNames(styles.wrap, { [styles.animated]: animated }, className)}
      style={{
        width: width(),
      }}
    />
  )
}
